<div class="company-slide-out-search">
  <div class="row">
    <div class="col-12 mt-4 mb-2">
      <span>Company Names or Identification Numbers</span>
    </div>
    <div class="col-12 mb-4">
      <span class="ey-float-label">
        <input
          class="form-control"
          id="items"
          name="items"
          [(ngModel)]="searchInput"
          [disabled]="false"
          #items="ngModel"
          maxlength="4000"
          appLabelFloat
        />
        <label for="items">Use ; as delimiter</label>
      </span>
    </div>
    <div class="col-10 mb-4">
      <button type="button" class="btn btn-default me-2" (click)="reset()">Reset</button>
      <button type="button" class="btn btn-primary" (click)="search()" [disabled]="!searchInput">Search</button>
    </div>
    <div class="col-2 mb-4">
      <span class="companies-search-count">Search Count: {{ searchData.totalCount }}</span>
    </div>
    <div class="col-12">
      <p-table
        [value]="companies$ | async"
        [lazy]="true"
        [lazyLoadOnInit]="false"
        [(selection)]="selectedCompanies"
        dataKey="comparableId"
        (onRowUnselect)="handleChange()"
        (onRowSelect)="handleChange()"
        (onHeaderCheckboxToggle)="handleChange()"
        styleClass="company-table"
      >
        <ng-template pTemplate="header">
          <tr class="header-row">
            <th class="col-company-table-checkbox">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th class="col-company-table-name">Company Name</th>
            <th class="col-company-table">Country</th>
            <th class="col-company-table">ID Number</th>
            <th class="col-company-table">Database</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-company let-rowIndex="rowIndex">
          <tr class="company-row">
            <td>
              <p-tableCheckbox [value]="{ comparableId: company.comparableId }"></p-tableCheckbox>
            </td>
            <td>
              <a (click)="selectCompany(company.comparableId, rowIndex)">{{ company.companyName }}</a>
            </td>
            <td>{{ company.countryName }}</td>
            <td>{{ company.bvdId }}</td>
            <td>{{ getDbNames(company.databases) }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr class="company-no-result">
            <td [attr.colspan]="5" class="text-center">No results to display</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="col-6 mt-1">
      <div *ngIf="selectedCompaniesCount$ | async as count">
        <a (click)="clearSelected()" class="clear-selection">
          <i class="material-icons">clear_all</i>
          <span class="clear-selection-text">Clear Selected ({{ count }})</span>
        </a>
      </div>
    </div>
    <div class="col-6 mt-1">
      <div class="company-paginator">
        <p-paginator
          #paginator
          [rows]="10"
          [totalRecords]="searchData.totalCount"
          (onPageChange)="paginate($event)"
          [class.slide-out-search-disabled]="searchData.totalCount === 0"
          [alwaysShow]="false"
        ></p-paginator>
      </div>
    </div>
  </div>
</div>
